module.exports = __webpack_public_path__ + "static/media/contacto.42f555d1.jpg";